/**
 * @module JobApplication
 */
(function JobApplication() {

    /**
     * Render the additional source element group
     * @param {dom} element
     */
    function renderAdditionalSource(element) {
        // only if formGroup is there
        var additionalContainer = element.find('.td-form-group-sourceAdditional');
        if(!additionalContainer) {
            return;
        }

        var that = this;

        this.hide = function() {
            additionalContainer.hide();
        };

        this.show = function() {
            additionalContainer.show();
        };
        this.hide();

        // on change of the sourceSelect element
        element.find('[name="--juzo_career-jobapplication[request][sourceSelect][]"]').change(function() {
            var selectElement = $('[name="--juzo_career-jobapplication[request][sourceSelect][]"]');
            var additionalTextElement = $('[name="--juzo_career-jobapplication[request][sourceAdditional]"]');

            // if value of last option equals selected option
            if(selectElement.val() == selectElement.find('option').last().attr('value')) {
                that.show();
            } else {
                that.hide();
                additionalTextElement.val('');
            }
        });


        // localize
        // the javascript plug-in is at
        // src/Packages/Plugins/Juzo.Event/Resources/Private/JavaScript/libs/moment-with-locales.js
        if (window.moment) {
            moment.locale($('html').attr('lang'));
        }

        //render datepicker html
        element.find('.datepicker').daterangepicker({
            "autoApply": true,
            "singleDatePicker": true,
            "showCustomRangeLabel": false,
            "opens": "center",
            "showDropdowns": true,
            "minYear": 1901,
            "maxYear": parseInt(moment().format('YYYY'),10),
            // override existing template:
            "template":
            '<div class="daterangepicker dropdown-menu juzo-career-jobapplication-daterangepicker-dropdown-menu">' +
                '<div class="calendar left">' +
                    '<div class="daterangepicker_input">' +
                        '<input class="input-mini form-control" type="text" name="daterangepicker_start" value="" />' +
                        '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
                            '<div class="calendar-time">' +
                                '<div></div>' +
                                 '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
                            '</div>' +
                        '</div>' +
                    '<div class="calendar-table"></div>' +
                '</div>' +
            '</div>'
        });

        // set initialempty filed for birthday ≤input> tag
        if(element.find('.datepicker').data('initialempty') === true) {
            element.find('.datepicker').val('');
        }

    }

    /**
     * Handles the upload fields behavior
     *
     * @param {Dom} element jQuery dom element
     */
    function uploadFields(element) {
        var $button = element.find('[data-career-upload="clear"]');
        var $inputElements = element.find('[type="file"]');
        var buttonVisible = true;
        var _this = this;

        var exceptionMessagesSelector = '[data-file-message]';
        var fileTooBigSelector = '[data-file-message="tooBig"]';
        var unacceptedFileExtensionSelector = '[data-file-message="unacceptedFileExtension"]';
        var unacceptedFileExtensionAndFileTooBigSelector = '[data-file-message="unacceptedFileExtensionAndFileTooBig"]';

        // shows the button
        this.showButton = function() {
            if(!buttonVisible) {
                $button.slideDown();
            }
            buttonVisible = true;
        };

        // hides the button
        this.hideButton = function() {
            if(buttonVisible) {
                $button.slideUp();
            }
            buttonVisible = false;
        };

        /**
         * Renders the exception messages
         *
         * @param {Event} event
         * @param {String} selector
         */
        this.renderExceptionMessage = function (event, selector) {
             $(event.currentTarget).parent().find(selector).slideDown();
        };

        /**
         * Hides the exception messages
         *
         * @param {Event} event
         * @param {String} selector
         */
        this.hideExceptionMessage = function (event, selector) {
            $(event.currentTarget).parent().find(selector).slideUp();
        };

        /**
         * Handles the uploaded file acceptance
         *
         * @param {Object} file
         * @param {Event} event
         */
        this.filesExceptionHandling = function (file, event) {
            var maxSize = $(event.currentTarget).attr('max-size');
            var filename = file.name;
            // splits the accepted file extensions to an array
            var acceptedFileExtensions = $(event.currentTarget).attr('accept').split(',');
            // get current file extension
            var currentFileExtension = (/[.]/.exec(filename)) ? '.' + /[^.]+$/.exec(filename) : undefined;

            // check current file for acceptance
            if (_this.isFileTooBig(file.size, maxSize) || _this.isAccecptedFileExtensions(acceptedFileExtensions, currentFileExtension)) {
                // cleanup for a new error message
                $(event.currentTarget).parent().find(exceptionMessagesSelector).slideUp();

                if (_this.isFileTooBig(file.size, maxSize) && !_this.isAccecptedFileExtensions(acceptedFileExtensions, currentFileExtension)) {
                    _this.renderExceptionMessage(event, fileTooBigSelector);
                }

                if(_this.isAccecptedFileExtensions(acceptedFileExtensions, currentFileExtension) && !_this.isFileTooBig(file.size, maxSize)) {
                    _this.renderExceptionMessage(event, unacceptedFileExtensionSelector);
                }

                if(_this.isAccecptedFileExtensions(acceptedFileExtensions, currentFileExtension) && _this.isFileTooBig(file.size, maxSize)) {
                    _this.renderExceptionMessage(event, unacceptedFileExtensionAndFileTooBigSelector);
                }

                // delete input value of file
                $(event.currentTarget).val('');
            } else {
                // otherwise hide all exception messages
                $(event.currentTarget).parent().find(exceptionMessagesSelector).slideUp();
            }
        };

        /**
         * Check if file is too big
         *
         * @param {Number} size of file
         * @param {Number} maxSize
         * @return {Boolean}
         */
        this.isFileTooBig = function (size, maxSize) {
            return size > maxSize;
        };

        /**
         * Check if file current extension is accepted
         *
         * @param {Array} acceptedFileExtensions
         * @param {String} currentFileExtension
         * @return {Boolean}
         */
        this.isAccecptedFileExtensions = function (acceptedFileExtensions, currentFileExtension) {
            return acceptedFileExtensions.indexOf(currentFileExtension) === -1 || typeof currentFileExtension === 'undefined';
        };

        // button action, clears the input fields
        $button.click(function() {
            $inputElements.val('');
            _this.hideButton();
            element.find(exceptionMessagesSelector).hide();
        });

        // on every change on file input fields
        $inputElements.change(function(event) {
            // set the button visibility
            $inputElements.each(function() {
                if( $(this).val().length) {
                    _this.showButton();
                }
            });

            // check the file size
            var files = event.currentTarget.files; // puts all files into an array

            // iterate all files (multiple possible)
            for (var x in files) {
                if (files.hasOwnProperty(x) || files[x] instanceof File) {
                     _this.filesExceptionHandling(files[x], event);
                }
            }
        });

        // clear initial
        $inputElements.val('');
        this.hideButton();
        element.find(fileTooBigSelector).hide();
    }


    // default dom.ready listener, features are not needed in neos backend
    $(document).ready(function () {
        $('.juzo-career-jobapplication').each(function (idx, element) {
            renderAdditionalSource($(element));
            uploadFields($(element));
        });
    });
})();



